import { useState } from "react";
import { Loader2, Send } from "lucide-react";
import { toast } from "sonner";
import { api, formatApiError } from "@/lib/api";
import { Reveal } from "./Reveal";

const EMPTY = { name: "", email: "", phone: "", subject: "", message: "", website: "" };

export const ContactForm = () => {
  const [f, setF] = useState(EMPTY);
  const [busy, setBusy] = useState(false);
  const [done, setDone] = useState(false);
  const set = (k) => (e) => setF({ ...f, [k]: e.target.value });
  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try { await api.post("/contact", f); setDone(true); setF(EMPTY); } catch (err) { toast.error(formatApiError(err)); } finally { setBusy(false); }
  };
  return (
    <section className="section contact-sec" id="contact" data-testid="contact-section">
      <div className="wrap">
        <Reveal>
          <p className="eyebrow">Questions?</p>
          <h2>Send us a message</h2>
          <p className="muted-sm">We reply by email, usually the same day.</p>
        </Reveal>
        {done ? (
          <div className="rv-form rv-thanks" data-testid="contact-thanks">
            <h3>Message sent</h3>
            <p>Thank you! We'll reply to your email shortly.</p>
            <button className="btn light" onClick={() => setDone(false)} data-testid="contact-send-another-button">Send another</button>
          </div>
        ) : (
          <form className="rv-form contact-form" onSubmit={submit} data-testid="contact-form">
            <div className="contact-row">
              <input required maxLength={80} placeholder="Your name" autoComplete="name" value={f.name} onChange={set("name")} data-testid="contact-name-input" />
              <input required type="email" maxLength={120} placeholder="Email" autoComplete="email" value={f.email} onChange={set("email")} data-testid="contact-email-input" />
            </div>
            <div className="contact-row">
              <input type="tel" maxLength={40} placeholder="Phone (optional)" autoComplete="tel" value={f.phone} onChange={set("phone")} data-testid="contact-phone-input" />
              <input maxLength={120} placeholder="Subject (optional)" value={f.subject} onChange={set("subject")} data-testid="contact-subject-input" />
            </div>
            <textarea required minLength={5} maxLength={3000} rows={5} placeholder="How can we help?" value={f.message} onChange={set("message")} data-testid="contact-message-input" />
            <input className="hp" tabIndex={-1} autoComplete="off" aria-hidden="true" value={f.website} onChange={set("website")} />
            <button className="btn gold" type="submit" disabled={busy} data-testid="contact-submit-button">{busy ? <Loader2 size={16} className="spin" /> : <><Send size={15} /> Send message</>}</button>
          </form>
        )}
      </div>
    </section>
  );
};
